import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-16" data-id="element-49">
      <div className="mx-auto max-w-4xl px-4" data-id="element-50">
        <div className="flex flex-col items-center gap-8 rounded-2xl border-2 border-gray-100 bg-white p-8 shadow-xl md:flex-row md:p-12" data-id="element-51">
          <div className="shrink-0" data-id="element-52">
            <ShieldCheck className="h-32 w-32 text-blue-600" data-id="element-53" />
          </div>
          <div data-id="element-54">
            <h2 className="mb-4 text-3xl font-bold text-gray-900" data-id="element-55">
              Garantía de Satisfacción
            </h2>
            <p className="text-lg leading-relaxed text-gray-600" data-id="element-56">
              Probalo durante 7 días. Si no te resulta útil como herramienta
              práctica para el aula, te devolvemos el 100% de tu dinero. Sin
              preguntas. Sin complicaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}